import React from "react";
import styled from "styled-components";
import PretendardText from "./../text/pretendardText";

const RedBtn = (props) => {
  return (
    <StyledRedBtn
      style={{
        ...props.style,
      }}
      onClick={props.onClick}
    >
      <PretendardText
        style={{
          color: "#cf6679",
          fontSize: "14px",
          fontWeight: "500",
          lineHeight: "22.75px",
          textAlign: "center",
        }}
      >
        {props.children}
      </PretendardText>
    </StyledRedBtn>
  );
};

export default RedBtn;

const StyledRedBtn = styled.button.attrs((props) => {})`
  width: fit-content;
  height: fit-content;
  padding: 3px 8px;
  border-radius: 4px;
  border: 1px solid #cf6679;
  background-color: inherit;
`;
